// extracted by mini-css-extract-plugin
export default {"logo":"styles-module__logo___wmGJT"};